export default __webpack_public_path__ + "static/media/Pickpocket's Belt of Engulfing Twilight.b483bfb3.jpg";